// removed by extract-text-webpack-plugin
module.exports = {"pricingWrapper":"_1m-Da4-VHFfHPYw4QGD5ML","couponWrapper":"uVUiB1TPG85hNI8dYyfqP","title":"gCt4t2ooUob6mmzSSW0xO","smallTitle":"_32-5lPuXkKP6uXhS2HyDwm","total":"FISnsKScDVrEJ776dsMYA","couponBonus":"_1CHiGgFqGcDCVVBx_w2Ioe","priceItem":"_1YJwcbYZ7y33oT2Az6CkpC","boldText":"_3o7oLMGEjrW8eUzKlaFuDt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpgradeRegularUserPackage/components/RegularPackages.scss
// module id = 1821
// module chunks = 0